import { render, staticRenderFns } from "./ElderResidents.vue?vue&type=template&id=cd738c16&scoped=true&"
import script from "./ElderResidents.vue?vue&type=script&lang=js&"
export * from "./ElderResidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd738c16",
  null
  
)

export default component.exports